<div class="mx-auto flex min-h-dvh w-full max-w-xl flex-col px-5 py-8 sm:px-8">
  <img src="/assets/logos/official/SHOUT_studio_logo_full_colour_white.svg" alt="SHOUT Studio" class="h-7 w-auto" />
  <div class="flex flex-1 flex-col items-center justify-center gap-6 text-center sm:gap-9">
    <div class="relative size-36 sm:size-44" aria-hidden="true">
      <div class="absolute inset-0 rounded-full border-2 border-white/20 border-t-white motion-safe:animate-spin"></div>
      <div class="absolute inset-5 rounded-full border border-dashed border-white/40 motion-safe:animate-spin"></div>
      <div class="absolute inset-12 flex items-center justify-center rounded-full bg-primary">
        <img src="/assets/logos/official/SHOUT_icon_white.svg" alt="" class="size-9" />
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <p class="m-0 text-sm font-bold uppercase tracking-wide text-fuchsia-200">SHOUT AI · Quick Brief</p>
      <h1 class="use-grotesque m-0 text-4xl font-bold leading-none sm:text-5xl">
        {{ brief.rewriting() ? 'Rewriting your brief' : 'Writing your brief' }}
      </h1>
      <p class="m-0 text-lg font-semibold text-white/80">
        SHOUT AI is building a {{ brief.format() === 'ugc' ? 'UGC' : 'creator' }} brief for {{ brief.summaryPromoting() || brief.brandName() }}.
      </p>
    </div>
    <div class="h-1.5 w-full overflow-hidden rounded-full bg-white/20" aria-hidden="true">
      <div class="h-full bg-gradient-to-r from-brand-studio to-white transition-all duration-200" [style.width.%]="(brief.thinkStage() / 5) * 100"></div>
    </div>
    <ol class="m-0 flex w-full list-none flex-col gap-3 p-0 text-left">
      @for (label of brief.stageLabels(); track label; let index = $index) {
        <li class="flex items-center gap-3 text-lg font-bold" [class]="stageState(index) === 'upcoming' ? 'text-white/45' : 'text-white'">
          <span class="flex size-6 shrink-0 items-center justify-center rounded-full border" [class]="stageState(index) === 'done' ? 'border-white bg-white text-primary' : 'border-white/40'" aria-hidden="true">
            @if (stageState(index) === 'done') {
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" class="size-3"><path d="M20 6 9 17l-5-5" /></svg>
            } @else if (stageState(index) === 'active') {
              <span class="size-3 rounded-full border-2 border-white/30 border-t-white motion-safe:animate-spin"></span>
            }
          </span>
          <p class="m-0">{{ label }}</p>
        </li>
      }
    </ol>
    <div class="flex flex-wrap justify-center gap-2">
      @for (chip of brief.insightChips(); track chip) {
        <p class="m-0 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-sm font-semibold">{{ chip }}</p>
      }
    </div>
  </div>
</div>
